module.exports = __webpack_public_path__ + "static/media/mobile.07a9dce2.png";